import React from 'react';
export const NavigationContext = React.createContext({});
export function useNavigationContext() {
    const context = React.useContext(NavigationContext);
    if (!context) {
        throw new Error(`Navigation compound components cannot be rendered outside the Navigation component`);
    }
    return context;
}
//# sourceMappingURL=NavigationContext.js.map